<template>
	<image-view class="login-image-view" v-on="$listeners" v-bind="$attrs">
		<div class="overlay"></div>
		<div class="window">
			<div class="title"></div>
			<div class="paragraph"></div>
			<div class="input"></div>
			<div class="input"></div>
			<div class="btn"></div>
		</div>
	</image-view>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>
	.login-image-view {
		.overlay {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0,0.5);
		}

		.window {
			position: absolute;
			right: 0;
			top: 0;
			width: 100px;
			height: 100%;
			background-color: white;

			& > .title {
				margin-left: 15%;
				margin-top: 50px;
				width: 30%;
				height: 8px;
				background-color: black;
			}

			& > .paragraph {
				margin-left: 15%;
				margin-top: 5px;
				margin-bottom: 10px;
				width: 70%;
				height: 5px;
				background-color: rgb(230, 230, 230);
			}

			& > .input {
				margin-left: 15%;
				margin-top: 5px;
				width: 70%;
				height: 8px;
				background-color: rgb(207, 207, 207);
			}

			& > .btn {
				margin-left: 15%;
				margin-top: 5px;
				width: 70%;
				height: 8px;
				background-color: #f7223f;
			}
		}
	}
</style>